module.exports = __webpack_public_path__ + "img/mirror.1d96b542.png";